import React, {Component} from 'react';
import { Button, message } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Title from '../../common/title';
import OtherTable from '../../common/otherTable';
import {ajax, unparam} from '../../../../../utils/common';

class Conclusion extends Component {
  state = {
    options: {
      credits: {
        enabled: false
      },
      chart: {
        height: 280
      },
      title: null,
      colors: this.props.chatColor,
      tooltip: {
        pointFormat: `${this.props.i18n.report.summaryInfo3}: <b>{point.y}</b><br/>${this.props.i18n.report.summaryInfo4}: <b>{point.strengthDesc}</b>`
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '{point.name}: {point.percentage:.1f}% {point.strengthDesc}',
            style: {
              color: 'rgba(0, 0, 0, 0.65)',
              fontSize: 12
            }
          }
        }
      },
      series: []
    }
  }

  signCharacterReport = (useful) => {
    const queryString = unparam(location.search);
    ajax({
      url: "/account/signCharacterReport",
      method: 'post',
      data: {
        hrInfo: queryString.hrInfo,
        useful
      }
    }).then(res => {
      this.props.updateUserInfo && this.props.updateUserInfo();
    }).catch(err => {
      err.message && message.error(err.message);
      console.log("result fail: ", err)
    });
  }

  // 下载报告
  downloadReport = () => {
    //获取页面参数
    const queryString = unparam(location.search);
    window.open("/oivi/api/file/videoReport/pdf?accountId=" + queryString.accountId);
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.summary && nextProps.summary.emos && this.state.options.series.length === 0) {
      const emos = nextProps.summary && nextProps.summary.emos || {};
      let arr = [];
      for(let i in emos) {
        if(i !== 'attention') {
          arr.push({
            name: emos[i].emotion,
            y: emos[i].score,
            strengthDesc: emos[i].strengthDesc
          });
        }
      }
      this.setState({
        options: {
          series: [{
            type: 'pie',
            innerSize: '60%',
            data: arr
          }]
        }
      });
    }
  }

  render() {
    const { options } = this.state;
    const { themeColor, i18n, summary, chatColor, useful } = this.props;

    const columns = () => {
      const arr = [{
        title: i18n.report.summaryInfo5,
        dataIndex: 'title',
        key: 'title',
        align: 'center'
      }];
      const emos = summary && summary.emos || {};
      let index = 0;
      for(let i in emos) {
        if(i !== 'attention') {
          arr.push({
            title: () => <div className="tableTitle"><span style={{backgroundColor: chatColor[index++]}} />{i18n.report.emotion[i]}</div>,
            dataIndex: i,
            key: i,
            align: 'center',
            ellipsis: true,
            render: (text, record) => <React.Fragment>
              {record[`${i}_strength`] === 1 ? <strong style={{color: 'black'}}>{text}</strong> : text}
            </React.Fragment>
          });
        }
      }
      return arr;
    }

    const dataSource = () => {
      const arr = [{
        key: 0,
        title: i18n.report.summaryInfo3
      }, {
        key: 1,
        title: i18n.report.summaryInfo4
      }];
      const emos = summary && summary.emos || {};
      for(let i in emos) {
        if(i !== 'attention') {
          arr[0][i] = emos[i].score;
          arr[1][i] = emos[i].strengthDesc;
          arr[1][`${i}_strength`] = emos[i].strength;
        }
      }
      return arr;
    }

    return (
      <div className="mrg25">
        <Title iconfont="icon-lujing13573">
          {{
            title: i18n.result.summaryTitle,
            content: <Button onClick={() => this.downloadReport()} type="primary" style={{backgroundColor: themeColor}}>{i18n.report.download}</Button>
          }}
        </Title>
        <div className="conclusionCon mgin60 mrgt16 borderBlack">
          <div className="conclusionConTopBox">
            <div className="conclusionConTop">
              <p dangerouslySetInnerHTML={{__html: summary.emos && summary.emos.attention && i18n.report.summaryInfo1.replace('${num}', `<span style="color: ${themeColor}"> ${summary.emos.attention.score}</span>`).replace('${degree}', summary.emos.attention.strengthDesc)}} />
              <p>{i18n.report.summaryInfo2}<span style={{color: themeColor}}>{summary.mbti && (summary.mbti.mbtiType + summary.mbti.result.split('——')[0])} </span>{summary.mbti && '——' + summary.mbti.result.split('——')[1]}</p>
            </div>
            <div className="expressionList">
              <div className="expressionBtn" onClick={() => useful != 1 && this.signCharacterReport(1)}
                   style={useful == 1 ? {color: '#fff', borderColor: themeColor, backgroundColor: themeColor, cursor: 'auto'} : {}}><span style={useful == 1 ? {color: '#fff'} : {}} className="iconfont icon-90tubiaoku-230" />{i18n.result.expressText1}</div>
              <div className="expressionBtn" onClick={() => useful != 0 && this.signCharacterReport(0)}
                   style={useful == 0 ? {color: '#fff', borderColor: themeColor, backgroundColor: themeColor, cursor: 'auto'} : {}}><span style={useful == 0 ? {color: '#fff'} : {}} className="iconfont icon-90tubiaoku-229" />{i18n.result.expressText2}</div>
            </div>
          </div>
          <div className="summaryTitle">
            <i style={{backgroundColor: themeColor}} />
            <p>{i18n.result.summaryInfo}</p>
          </div>
          <div className="pieChatBox">
            <HighchartsReact
              highcharts={Highcharts}
              options={options}
            />
          </div>
          <div className="tableBox">
            {summary && summary.emos && <OtherTable columns={columns()} dataSource={dataSource()} />}
          </div>
        </div>
      </div>
    );
  }
}

export default Conclusion;
